"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewZip extends new_item_1.default {
    constructor(newZip) {
        super();
        this.siteId = newZip.siteId;
        this.files = newZip.files;
        this.location = newZip.location;
    }
}
exports.default = NewZip;
//# sourceMappingURL=new-zip.js.map